import React from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';

interface EmptyStateProps {
  icon?: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void;
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
}: EmptyStateProps) {
  return (
    <div className="empty-state">
      <div className="empty-state-content">
        {Icon && (
          <div className="empty-state-icon">
            <Icon className="icon" />
          </div>
        )}
        <h3 className="empty-state-title">{title}</h3>
        <p className="empty-state-description">{description}</p>
        {(actionLabel || secondaryActionLabel) && (
          <div className="empty-state-actions">
            {actionLabel && onAction && (
              <button onClick={onAction} className="btn btn-primary">
                <PlusIcon className="btn-icon" />
                {actionLabel}
              </button>
            )}
            {secondaryActionLabel && onSecondaryAction && (
              <button onClick={onSecondaryAction} className="btn btn-secondary">
                {secondaryActionLabel}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
